import React from "react";

interface IRequestProps {
  className?: string;
}

const Request = ({ className }: IRequestProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 69.439 67.592"
  >
    <path
      d="M949.842-292.984l-9.4-7.753v-8.228a2.042,2.042,0,0,0-2.042-2.044H927.991l-10.821-8.93a2.051,2.051,0,0,0-2.6,0l-10.824,8.93H893.337a2.042,2.042,0,0,0-2.042,2.044v8.228l-9.4,7.753-.005.008a2.057,2.057,0,0,0-.741,1.576v36.544a2.042,2.042,0,0,0,2.042,2.044h65.356a2.04,2.04,0,0,0,2.042-2.044V-291.4a2.115,2.115,0,0,0-.746-1.584Zm-3.337,33.394-17.479-16.491c10.669-7.036,7.837-5.17,17.479-11.526Zm-59.884-31.994,4.674-3.857v6.938C888.728-290.2,887.638-290.914,886.621-291.584Zm8.759-15.34h40.979v21.115L915.87-272.3c-9.841-6.489-5.4-3.555-20.489-13.512Zm20.489-8.79,5.7,4.705H910.166Zm29.246,24.131c-.983.649-2.188,1.44-4.674,3.082v-6.938l4.674,3.857Zm-59.881,3.977s17.045,11.239,17.476,11.526L885.234-259.59Zm20.978,13.835,8.533,5.627a2.055,2.055,0,0,0,2.249,0l8.53-5.627L943.408-256.9H888.332Z"
      transform="translate(-881.149 320.404)"
    />
    <path
      d="M894.142-305.4a2.042,2.042,0,0,0,2.044-2.041,1.858,1.858,0,0,1,1.907-1.863,1.88,1.88,0,0,1,1.818,1.815c.029,1.243-.814,1.408-1.85,2.632A8.584,8.584,0,0,0,896-299.234a2.044,2.044,0,0,0,2.044,2.041,2.042,2.042,0,0,0,2.042-2.107,4.592,4.592,0,0,1,1.723-3.541,5.911,5.911,0,0,0,2.181-4.745,5.94,5.94,0,0,0-5.8-5.8,5.944,5.944,0,0,0-6.09,5.948A2.042,2.042,0,0,0,894.142-305.4Z"
      transform="translate(-863.328 331.816)"
    />
    <path
      d="M895.631-306.844a2.044,2.044,0,0,0-2.044,2.041v1.2a2.043,2.043,0,0,0,2.044,2.044,2.042,2.042,0,0,0,2.042-2.044v-1.2A2.042,2.042,0,0,0,895.631-306.844Z"
      transform="translate(-860.91 342.468)"
    />
  </svg>
);

export default Request;
